/**
 * Eroarea runtime-ului când un fișier de cod nu se poate descărca: Turbopack (buildul de
 * producție) aruncă `Failed to load chunk ${path} from module ${id}`; webpack, `ChunkLoadError`.
 */
export function isChunkLoadError(err: unknown): boolean {
  const e = err as { name?: unknown; message?: unknown } | null | undefined;
  return /Failed to load chunk|ChunkLoadError|Loading chunk \S+ failed/i.test(`${e?.name ?? ''} ${e?.message ?? ''}`);
}

/**
 * Mesajul afișat când previzualizarea unui document nu se poate încărca. Cauza obișnuită:
 * pagina rulează un build mai vechi decât cel de pe server (tab lăsat deschis peste un deploy),
 * iar fișierele lui nu mai există — reîncărcarea aduce versiunea curentă. Un fișier picat nu se
 * mai cere din nou până la reîncărcare (runtime-ul își păstrează promisiunea), deci și fără
 * internet soluția e reîncărcarea, după ce revine conexiunea. La alte erori reîncărcarea nu
 * ajută, deci nu o promitem.
 */
export function previewLoadFailureNotice(
  err: unknown,
  online: boolean,
): { title: string; description: string; reload: boolean } {
  if (!isChunkLoadError(err)) {
    return {
      title: 'Documentul nu s-a putut deschide',
      description: 'A apărut o eroare în aplicație. Dacă se repetă, scrie-ne la contact@softfactura.ro.',
      reload: false,
    };
  }
  if (!online) {
    return {
      title: 'Nu ești conectat la internet',
      description: 'Reîncarcă pagina după ce revine conexiunea.',
      reload: false,
    };
  }
  return {
    title: 'A apărut o versiune nouă a aplicației',
    description: 'Reîncarcă pagina ca să deschizi documentul.',
    reload: true,
  };
}
